import PieChartElement from '@/views/elements/chart/PieChartElement';
import classNames from 'classnames/bind';
import styles from './AllocationChartRealtime.module.scss';
import { useEffect, useState } from 'react';
import { Box, Stack } from '@mui/system';
import { useInstrumentsDynamic } from '@/controllers/gridManager/PriceboardManager';
import { useGetIndustry } from '@/controllers/gridManager/appManager/appManager';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

const cx = classNames.bind(styles);

type AllocationChartRealtimeProps = {
  accountId?: string
  masterCustodycd?: string,
  emitter?: any
}

export default function AllocationChartRealtime({ emitter }: AllocationChartRealtimeProps) {
  const { t } = useTranslation()
  const [data, setData] = useState<any>([]);
  const [listSymbol, setListSymbol] = useState<string[]>([])
  const [type, setType] = useState(0)
  const { instrumentsDynamic } = useInstrumentsDynamic()
  const { industry } = useGetIndustry()

  const sumMPComputed = (marketprice?: number, symbol?: string | undefined) => data ? data.reduce((accumulator: any, portfolio: any) => { 
    if (portfolio.symbol === symbol) portfolio.marketprice = marketprice
    return accumulator + (portfolio.marketprice * portfolio.total_trade)
  }, 0) : 0;

  useEffect(() => {
    emitter.on('message', (data: any) => {
      setData(data)
      setListSymbol(data.map((item: any) => item.symbol))
    });
  }, [])

  useEffect(() => {
    let isChanged = false
    let _data = _.cloneDeep(data)
    _data.forEach((portfolio: any) => {
      let instrument: any = instrumentsDynamic?.find((i: any) => portfolio.symbol === i.SB)
      if (instrument && instrument.CP && instrument.CP !== portfolio.marketprice) {
        portfolio.marketprice = instrument.CP
        isChanged = true
      }
    })
    if (isChanged) setData(_data)
  }, [instrumentsDynamic])

  const stocks = () => {
    let sumMP = sumMPComputed()
    return (
      data?.map(
        (portfolio: {
          symbol: string;
          total_trade: number;
          marketprice: number;
        }) => {
          return {
            name: portfolio.symbol,
            value: (portfolio.marketprice * portfolio.total_trade / sumMP) * 100,
          };
        }
      ) || []
    );
  };

  const industries = industry.map((subIndustry: any) => {
    const matchedCodes = listSymbol.filter((code: any) => subIndustry?.codeList?.includes(code));
    return {
      industryNameEn: subIndustry.industryNameEn,
      industryName: subIndustry.industryName,
      matchedCodes: matchedCodes
    };
  });

  const industriesOwned = industries.filter((item: any) => item.matchedCodes.length > 0);

  const filterWithoutMoney = listSymbol.filter((code: any) => code !== 'Tiền')

  const unmatchedCodes = filterWithoutMoney.filter((code: any) => !industries.some((subIndustry: any) => subIndustry.matchedCodes.includes(code)));

  industriesOwned.push({
    industryName: "Tiền",  // Ngành khác
    industryNameEn: "Money",
    matchedCodes: ["Tiền"]
  });

  if (unmatchedCodes.length > 0) {
    industriesOwned.push({
      industryName: "Khác",  // Ngành khác
      industryNameEn: "Other",
      matchedCodes: unmatchedCodes
    });
  }

  const data4Industry = industriesOwned.map((item: any) => {
    let sum = 0
    for (let index = 0; index < data.length; index++) {
      const element = stocks()[index];
      if (item?.matchedCodes.includes(element.name)) {
        sum += element.value
      }
    }
    return { name: item.industryName, value: sum }
  })

  const cookedData = (data: any[]): any[] => {
    let result: any[] = []
    let sorted = _.cloneDeep(data.sort((item: any, item2: any) => item2.value - item.value))
    let MoneyIndex = sorted.findIndex((item: any) => item.name === 'Tiền')
    let money = MoneyIndex > 1 ? sorted.splice(MoneyIndex, 1)[0] : null
    let theOtherIndex = sorted.findIndex((item: any) => item.name === 'Khác')
    let theOther = theOtherIndex > 1 ? sorted.splice(theOtherIndex, 1)[0] : null
    let main = sorted.slice(0, 5);
    let others = sorted.slice(5);
    if (!!theOther) others.push(theOther)
    let othersReduced = others.reduce((accumulator: any, other: any) => ({
      name: "Khác",
      value: accumulator.value + other.value
    }), {
      value: 0,
      name: "Khác"
    } as any)
    if (!!money) {
      main.push(money)
      main = main.sort()
    }
    if (othersReduced.value > 0) main.push(othersReduced)
    result = main
    return result
  }

  return (
    <Stack spacing='20px' p='20px' direction='column' className={cx("allocation")}>
      <Stack direction='row' alignItems='center' justifyContent='space-between'>
        <TypographyElement FontSizeElement='16px' FontWeightElement={700}>{t('copytrade.chart.allocation.title')}</TypographyElement>
        <Stack className={cx("allocation__switch")} direction='row'>
          <Box className={cx("allocation__switch-thumb")} sx={{ left: `${type * 60}px` }}></Box>
          <TypographyElement onClick={() => setType(0)} className={cx("allocation__switch-content")}>{t('copytrade.chart.allocation.instrument')}</TypographyElement>
          <TypographyElement onClick={() => setType(1)} className={cx("allocation__switch-content")}>{t('copytrade.chart.allocation.industry')}</TypographyElement>
        </Stack>
      </Stack>
      <div className={cx("allocation__body")}>
        <PieChartElement
          dataSeries={type === 0 ? cookedData(stocks()) : cookedData(data4Industry)}
          isLongLabel={type === 1}
        />
      </div>
    </Stack>
  )
}










